"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCustomerFromCode = exports.isCustomer = exports.CustomerFromBarcode = exports.CustomerToBarcode = void 0;
const z = __importStar(require("zod"));
const types_1 = require("../types");
const utils_1 = require("../utils");
exports.CustomerToBarcode = z.object({
    sourceId: z.number().int(),
    workspaceId: z.number().int(),
    deliveryGroupId: z.number().int(),
    boxId: z.number().int(),
    productId: z.number().int(),
    index: z.number().int(),
});
exports.CustomerFromBarcode = z.object({
    type: z.number().int(),
    sourceId: z.number().int(),
    workspaceId: z.number().int(),
    deliveryGroupId: z.number().int(),
    boxId: z.number().int(),
    productId: z.number().int(),
    index: z.number().int(),
});
const isCustomer = (params) => 'type' in params && params.type !== undefined && params.type === Number(types_1.type.customer);
exports.isCustomer = isCustomer;
const isCustomerFromCode = (code) => (0, exports.isCustomer)((0, utils_1.objectFromCode)(code));
exports.isCustomerFromCode = isCustomerFromCode;
//# sourceMappingURL=customer.js.map